/* Draft-theme adapter for the existing SoFly Accounts session. */
(() => {
  const origin = 'https://account.sofly.io', channel = 'sofly-store:v1';
  const frame = document.createElement('iframe');
  frame.src = `${origin}/storefront-bridge.html?v=3`; frame.title = 'SoFly account connection'; frame.hidden = true;
  frame.referrerPolicy = 'no-referrer';
  let loaded = false, state = null, refreshing = false;
  const pending = new Map();
  function request(action, value = {}) {
    if (!loaded) return Promise.reject(new Error('Accounts is connecting. Please try again shortly.'));
    const id = crypto.randomUUID();
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => { pending.delete(id); reject(new Error('Accounts could not sync. Open your SoFly account and try again.')); }, 20000);
      pending.set(id, {resolve, reject, timeout, action});
      frame.contentWindow.postMessage({channel, id, action, ...value}, origin);
    });
  }
  function apply(next) {
    if (JSON.stringify(state) === JSON.stringify(next)) return;
    state = next;
    document.documentElement.dataset.sfAccount = state.authenticated ? 'signed-in' : 'guest';
    for (const link of document.querySelectorAll('[data-sf-account-link]')) {
      link.setAttribute('aria-label', state.authenticated ? 'Open your SoFly account — signed in' : 'Sign in to your SoFly account');
      const label = link.querySelector('.visually-hidden'); if (label) label.textContent = state.authenticated ? 'My SoFly account' : 'Sign in to SoFly';
    }
    for (const wrapper of document.querySelectorAll('[data-sf-wishlist-product]')) {
      const button = wrapper.querySelector('[data-sf-wishlist-open]');
      if (!button) continue;
      if (state.authenticated) {
        const saved = state.wishlist.includes(wrapper.dataset.sfWishlistProduct);
        button.dataset.bladeState = saved ? 'saved' : 'unsaved'; button.setAttribute('aria-pressed', String(saved));
        button.querySelector('[data-sf-wishlist-label]').textContent = saved ? 'Saved' : 'Add to wishlist';
        button.removeAttribute('aria-haspopup'); button.removeAttribute('aria-expanded');
      } else {
        button.dataset.bladeState = 'unsaved'; button.removeAttribute('aria-pressed');
        button.querySelector('[data-sf-wishlist-label]').textContent = 'Add to wishlist';
        button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-expanded', 'false');
      }
    }
    if (state.authenticated) window.SoFlyAppearance?.apply(state.appearance, false);
    document.dispatchEvent(new CustomEvent('sofly:account-state', {detail: state}));
  }
  window.SoFlyAccount = Object.freeze({getState: () => state, socialClub: () => request('socialClub')});
  addEventListener('message', event => {
    if (event.origin !== origin || event.source !== frame.contentWindow || event.data?.channel !== channel) return;
    const message = event.data, operation = pending.get(message.id);
    if (!operation || operation.action !== message.action) return;
    clearTimeout(operation.timeout); pending.delete(message.id);
    if (!message.ok) { operation.reject(new Error(message.error || 'Accounts could not sync. Please try again.')); return; }
    if (message.state) {
      if (typeof message.state.authenticated !== 'boolean' || !Array.isArray(message.state.wishlist) || !Array.isArray(message.state.ownedProductIds)) { operation.reject(new Error('Accounts returned an invalid sync response.')); return; }
      apply(message.state);
    }
    operation.resolve(message);
  });
  async function refresh() {
    if (refreshing || !loaded || document.hidden || pending.size) return;
    refreshing = true;
    try { await request('status'); } catch { /* Keep ordinary account navigation usable. */ }
    finally { refreshing = false; }
  }
  frame.addEventListener('load', async () => {
    loaded = true; await refresh();
    try { const result = await request('catalogue'); document.dispatchEvent(new CustomEvent('sofly:store-ranking', {detail: result.products})); } catch { /* Leave honestly labelled collection order. */ }
  });
  document.body.append(frame);
  addEventListener('focus', refresh);
  addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) void refresh(); });
  setInterval(refresh, 60000);
  document.addEventListener('shopify:section:load', () => { if (state) apply(state); });
  document.addEventListener('sofly:appearance-change', async event => {
    if (!state?.authenticated) return;
    try { await request('appearance', {appearance: event.detail}); } catch { /* The local selection remains usable; no remote-save claim. */ }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-sf-wishlist-open], [data-sf-wishlist-panel-toggle]');
    if (!button || !state?.authenticated) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const wrapper = button.closest('[data-sf-wishlist-product], [data-sf-wishlist-item]'), handle = wrapper.dataset.sfWishlistProduct || wrapper.dataset.sfWishlistItem;
    const status = wrapper.querySelector('[data-sf-account-wishlist-status]');
    const saved = !state.wishlist.includes(handle);
    button.disabled = true; button.setAttribute('aria-busy', 'true'); status.textContent = '';
    try { await request('wishlist', {handle, saved}); status.textContent = ''; if (saved) window.SoFlyWishlistCelebration?.play(button); }
    catch (error) { status.textContent = error.message; }
    finally { button.disabled = false; button.removeAttribute('aria-busy'); }
  }, true);
})();
